// extracted by mini-css-extract-plugin
module.exports = {"create-session":"styles_create-session__A4m0u","create-patient-button":"styles_create-patient-button__1ct43"};